import CrudBase from '../../../CrudBase';
import itens from './itens';
import axios from '../../../../axios-common';

class PedidosVendaAPI extends CrudBase {
    // Lista as situações
  listSituacoes = (text) => axios.get(`${this.endpoint}/situacoes?text=${text}`);
  listPedidosAcompanhamento = data => axios.post(`${this.endpoint}/pedidos-acompanhamento`, data);
  listPedidosCarteira = data => axios.post(`${this.endpoint}/pedidos-carteira`, data);
  listPedidosFaturado = data => axios.post(`${this.endpoint}/pedidos-faturado`, data);
  defaultMethods = {
    ...this.defaultMethods,
    listSituacoes: this.listSituacoes,
    listPedidosAcompanhamento: this.listPedidosAcompanhamento,
    listPedidosCarteira: this.listPedidosCarteira,
    listPedidosFaturado: this.listPedidosFaturado,
  }
}

const venda = new PedidosVendaAPI('api/comercial/pedidos/venda');

export default {
  ...venda.defaultMethods,
  itens,
}
